import React from 'react';
import { connect } from 'react-redux';
import { showOverlay  } from '../actions';
import CommonUtil from '../../../../../utils/commonUtil';

const ColorPicker = ({ showOverlay, selectedTheme, lables, disabled=false}) => {
    
    const handleClick = () => {
        if(disabled){
            return;
        }
        showOverlay();
    }
    
    return(
    <div className="row">
        <div className="col-sm-12">
            <div className="event-color-title event-color-title-align">

                {CommonUtil.getLabel(lables.createEventStep2, 'createEventStep2.colorContainerHeading.label')}
            </div>
            <div className="event-color-selection" onClick={handleClick} style={{cursor:disabled ? 'not-allowed' : 'pointer'}} >
                <span>{CommonUtil.getLabel(lables.createEventStep2, 'createEventStep2.color.label')}</span>
                <span>{selectedTheme?.title}{(selectedTheme?.isDefault) && ' (default)'}</span>
                <i class="iconRight icon-flecha_lightsvg_derecha"></i>
            </div>
        </div>
    </div>
);
}


export default connect(null, { showOverlay })(ColorPicker);